import React from "react";
import "./InTheWild.css";

const InTheWild = () => {
  return (
    <section className="hm-wild-section">
      <div className="hm-wild-container">
        {/* Header Section */}
        <div className="hm-wild-header">
          <span className="hm-wild-tag">MULTI-PURPOSE ADHESIVE</span>
          <h2 className="hm-wild-title">Made for every repair &amp; craft</h2>
          <p className="hm-wild-subtitle">
            From smartphone screens and delicate jewelry to leather, metal, and glass,
            MultiFct B-7000 delivers an ultra-strong, clear, and flexible bond.
          </p>
        </div>

        {/* 3-Column Bento Grid */}
        <div className="hm-wild-grid">
          {/* Card 1: Tall Left Column (Spans 2 rows) - Phone / Micro Repair */}
          <div className="hm-wild-card hm-wild-card-tall">
            <div className="hm-card-media-wrapper">
              <img
                src="/images/b7000-repair.jpg"
                alt="B-7000 precision needle tip phone repair"
                className="hm-wild-img hm-img-cover"
              />
            </div>
            <div className="hm-card-overlay">
              <span className="hm-overlay-caption">Precision needle tip for micro repairs</span>
            </div>
          </div>

          {/* Card 2: Center Top - Waterproof & Clear */}
          <div className="hm-wild-card">
            <div className="hm-card-media-wrapper">
              <img
                src="/images/b7000-waterproof.jpg"
                alt="Waterproof and crystal clear drying glue"
                className="hm-wild-img hm-img-cover"
              />
            </div>
            <div className="hm-card-overlay">
              <span className="hm-overlay-caption">Waterproof &amp; dries 100% crystal clear</span>
            </div>
          </div>

          {/* Card 3: Right Top - Jewelry & DIY Crafts */}
          <div className="hm-wild-card hm-wild-card-craft">
            <div className="hm-card-badge-top">
              <span>Jewelry &amp; DIY Crafts</span>
            </div>
            <div className="hm-card-media-wrapper">
              <img
                src="/images/b7000-jewelry.jpg"
                alt="Jewelry rhinestones and craft DIY bonding"
                className="hm-wild-img hm-img-cover"
              />
            </div>
            <div className="hm-card-overlay">
              <span className="hm-overlay-caption">High elasticity &amp; impact resistant</span>
            </div>
          </div>

          {/* Card 4: Center Bottom - Multi-Surface Bonding */}
          <div className="hm-wild-card">
            <div className="hm-card-media-wrapper">
              <img
                src="/images/b7000-multisurface.jpg"
                alt="Multi surface bonding: leather, metal, wood, acrylic"
                className="hm-wild-img hm-img-cover"
              />
            </div>
            <div className="hm-card-overlay">
              <span className="hm-overlay-caption">Bonds glass, metal, leather &amp; plastics</span>
            </div>
          </div>

          {/* Card 5: Right Bottom - Specs & Anti-Clogging Pin Cap */}
          <div className="hm-wild-card hm-wild-card-specs">
            <div className="hm-card-badge-top hm-specs-badge">
              <span>50ML / 1.68 FL.OZ</span>
            </div>
            <div className="hm-card-media-wrapper hm-specs-media-wrapper">
              <img
                src="/images/b7000-specs.jpg"
                alt="B-7000 50ml tube with anti-clogging pin cap"
                className="hm-wild-img hm-img-contain"
              />
              {/* Anti-clogging tag */}
              <div className="hm-specs-tag-callout">
                <span>✦ Built-in Anti-Clog Pin</span>
              </div>
            </div>
            <div className="hm-card-overlay">
              <span className="hm-overlay-caption">50ml tube with anti-clogging pin cap</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InTheWild;
